import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function OPVUseCase() {
  return (
    <>
    <section
      id="opvs"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">
        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            OPVs (Organic Photovoltaics)
          </h1>
          <p className="text-slate-300 space-y-2">
            OPVs are a class of solar cells that use organic molecules or polymers to convert sunlight into electricity.
            Unlike traditional silicon photovoltaics, OPVs can be made lightweight, flexible, semi-transparent, and printed using low-cost, solution-processable materials.
            This opens up applications in building-integrated photovoltaics, wearable power sources, and energy-harvesting devices where rigid panels aren't practical.

            <br /><br />

            Modern OPV devices typically use a donor–acceptor architecture, where light absorption, exciton generation, charge separation, and transport must all be finely balanced.
            State-of-the-art OPVs often use non-fullerene acceptors (NFAs) alongside tuned polymer or small-molecule donors to achieve power conversion efficiencies over 19% in lab conditions.
            Key design considerations include absorption spectra alignment with the solar spectrum, low exciton binding energies, optimal frontier orbital offsets, and favourable bulk heterojunction morphology.

            <br /><br />

             A promising emerging route for boosting OPV efficiency is <strong>singlet fission</strong><sup>[1]</sup> — a process where one high-energy singlet exciton splits into two lower-energy triplet excitons, effectively doubling the number of charge carriers produced from a single photon.
  This can increase photocurrent and enhance overall power conversion efficiency beyond the Shockley–Queisser limit.
            <br /><br />

            OPVs represent a promising path toward sustainable, printable solar energy with lower embodied carbon and unique form factors compared to inorganic photovoltaics.
          </p>
        </div>

        {/* How Apoello Helps */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
          <ul className="list-disc list-inside text-slate-300 space-y-2">
            <li>
              Search a 50M+ molecule database for OPV metrics: optical gap, ΔEST, oscillator strength, orbital alignment.
            </li>
            <li>
              Predict key properties: exciton binding energy, reorganisation energy.
            </li>
            <li>
              Identify candidates with complementary absorption to boost spectral coverage in tandem devices.
            </li>
            <li>
              Directly procure ready-to-order molecules or precursors.
            </li>
          </ul>
        </div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why it matters</h2>
          <p className="text-slate-300 max-w-3xl">
            OPV innovation is often slowed by poor material compatibility and time-consuming synthesis–test cycles.
            DiaDEM™ accelerates discovery by screening electronic and photophysical properties in silico — enabling rapid identification of materials with real device potential.
            This reduces wasted effort and accelerates your route to efficient, stable organic solar cells.
          </p>
        </div>

{/* References from our research group */}
<div className="space-y-4 pt-10">
  <h2 className="text-2xl font-semibold text-orange-300">
    References from our group
  </h2>
  <ol className="list-decimal list-inside text-slate-400 space-y-1 text-sm">
    <li>
      Padula, D., Omar, Ö. H., Nematiaram, T. & Troisi, A. <i>Singlet fission molecules among known compounds: finding a few needles in a haystack</i>, Energy Environ. Sci. (2019).{" "}
      <a
        href="https://doi.org/10.1039/C9EE01508F"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#F89B3F] underline"
      >
        Link ↗
      </a>
    </li>
  </ol>
</div>


        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>
      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}